import React from 'react';
import { Link } from 'react-router-dom';

import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

export interface WizardStepHeaderProps {
	title: React.ReactNode;
	subtitle?: React.ReactNode;
	/**
	 * Material Symbols icon name shown in the brand-tinted square on the left of
	 * the header. Optional — omit to render the header without an icon.
	 */
	iconName?: string;
	/**
	 * If true, render a close (×) link back to the booking-detailed view. Only rendered
	 * when `bookingToEditId` is supplied (i.e. alteration mode).
	 */
	showCloseLink?: boolean;
	bookingToEditId?: string;
	/**
	 * Extra content rendered inline with the heading (e.g. the alteration cross icon
	 * already lives in some tabs). Use only when the standard close-link slot doesn't
	 * cover it.
	 */
	endAdornment?: React.ReactNode;
	/** Optional className appended to the wrapper. */
	className?: string;
}

export function WizardStepHeader({
	title,
	subtitle,
	iconName,
	showCloseLink,
	bookingToEditId,
	endAdornment,
	className,
}: WizardStepHeaderProps) {
	const closeLink =
		showCloseLink && bookingToEditId ? (
			<Link to={`/bookings/${bookingToEditId}`} className="wizard-step-header__close" aria-label="Close">
				<Icon name="cross" classname="icon" />
			</Link>
		) : null;

	return (
		<header className={`wizard-step-header${className ? ` ${className}` : ''}`}>
			{iconName && (
				<span className="wizard-step-header__icon" aria-hidden="true">
					<Icon name={iconName} useMaterialIcons />
				</span>
			)}
			<div className="wizard-step-header__text">
				<h2 className="wizard-step-header__title">{title}</h2>
				{subtitle && <p className="wizard-step-header__subtitle">{subtitle}</p>}
			</div>
			{(closeLink || endAdornment) && (
				<div className="wizard-step-header__actions">
					{endAdornment}
					{closeLink}
				</div>
			)}
		</header>
	);
}
